<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent scrollable max-width="500">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title class="black--text w-100 ta-c headline">อัพโหลดรูปต้นไม้เพิ่มเติม</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form">
            <v-container grid-list-md pa-0 class="modal_loading" v-if="loading_save">
            </v-container>
            <v-container grid-list-md pa-0>
              <v-layout row wrap justify-center >
                <v-flex xs12 sm12 md12>
                  <v-text-field
                  label="ต้นไม้ที่ปลูก"
                  v-model="plant_name"
                  solo
                  item-text="plant_name"
                  item-value="plant_id"
                  hide-details
                  persistent-hint
                  color="blue"
                  required
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-center >
                <v-flex xs12 sm12 md12>
                  <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  color="blue"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="dateFormatted"
                    readonly
                    prepend-inner-icon="event"
                    label="วันที่ถ่ายรูป"
                    solo
                    hide-details
                    v-on="on"
                    color="blue"
                    @blur="date = parseDate(dateFormatted)"
                    :rules="nameRules"
                    required
                    ></v-text-field>
                  </template>
                  <v-date-picker locale="th" v-model="date" no-title @input="menu = false"></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>

            <v-layout row wrap justify-center mt-2 >
              <v-flex xs12 md12 style="max-width:100%">
                <div style="max-width:100%;" class="pointer">
                  <v-layout row wrap>
                    <v-flex xs12 md12 class="ta-c">
                      <div outline :class="[check ? 'border-upload-warning' : 'border-upload']" block @click="pickFile" style="height: 140px; white-space: unset !important; overflow-y: auto;" id="upload_tree">
                        <input ref="image_input_upload" type="file" multiple @change="onFileChange" style="display: none" accept="image/*" />
                        <div v-if="attachment.length == []"><v-icon class="mr-1">camera_alt</v-icon><span class="title">อัพโหลดรูปต้นไม้</span></div>
                        <div v-else style="max-height:120px;">
                          <span v-for="(att,index) in attachment" :key="index">
                            <v-chip close @input="remove(att.name)">
                              <v-flex>{{att.name}}</v-flex>
                            </v-chip>
                          </span>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>

          </v-container>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="ta-c jc-c">
        <v-btn color="green darken-1" flat @click="dialog = false">ยกเลิก</v-btn>
        <v-btn color="primary" round @click="submit()" :loading="loading_save">บันทึก</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-layout>
</template>

<script>
var _ = require('lodash')
import { Decode } from '@/services'
import { handleAjaxError } from '@/utils/common'
export default {
  data(){
    return{
      dateFormatted: '',
      date: '',
      card_id: '',
      attachment: [],
      dialog: false,
      loading_save: false,
      menu: false,
      check: false,
      loading: false,
      nameRules: [
        v => !!v || 'Name is required'
      ],
      plant_id: '',
      plant_name: '',
      user_plant_id: ''
    }
  },
  watch: {
    date () {
      this.dateFormatted = this.formatDate(this.date)
    },
    attachment () {
      if (this.attachment.length !== 0){
        this.check = false
      }
    }
  },
  created(){
    var result = Decode.decode(this.$cookies.get('token'))
    this.card_id = JSON.parse(result).card_id
  },
  methods:{
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      var year_thai = parseInt(year) + 543
      return `${day}/${month}/${year_thai}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      var year_2 = parseInt(year) - 543
      return `${year_2}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length)
      return;

      let new_files = _.filter(files, (file) => {
        var duplicate = false
        _.each(this.attachment, (attachment) => {
          if (attachment.name == file.name) {
            duplicate = true
          }
        })
        if (duplicate) {
          return false
        }
        return true
      })

      this.createImage(new_files);
      this.$refs['image_input_upload'].value = ''

    },
    pickFile () {
      this.$refs.image_input_upload.click()
    },
    createImage(files) {
      for (var i=0; i<files.length; i++) {
        this.attachment.push({ no: this.attachment.length, type:files[i].type, name:files[i].name, file: files[i]});
      }
    },
    remove(name) {
      this.attachment.splice(_.findIndex(this.attachment, {name}), 1)
    },
    openDialog(plant_name, user_plant_id, plant_id){
      this.dialog = true
      this.plant_name = plant_name
      this.user_plant_id = user_plant_id
      this.plant_id = plant_id
      this.loading_save = false
      this.$refs.form.resetValidation()
      this.date = ''
      this.attachment = []
    },
    submit(){
      this.loading_save = true
      if (this.$refs.form.validate()) {
        if (this.attachment.length !== 0) {
          var formData = new FormData()
          formData.append('card_id', this.card_id)
          formData.append('user_plant_id', this.user_plant_id)
          formData.append('plant_id', this.plant_id)
          formData.append('date', this.date)
          this.attachment.forEach((attach) => {
            formData.append('attachment', attach.file)
          })
          // for (var pair of formData.entries()) {
          //   console.log(pair[0]+ ', ' + pair[1]);
          // }

          this.axios.post(process.env.VUE_APP_IPFLASK + '/insertImagePlant', formData).then((response) => {
            if (response.data === 'Insert Images Success') {
              this.date = ''
              this.attachment = []
              this.loading_save = false
              this.$emit('fetch', true)
              this.$swal('บันทึกการปลูกต้นไม้เรียบร้อย','','success');
              this.dialog = false
            } else {
              this.$swal('บันทึกไม่สำเร็จ','กรุณาลองใหม่อีกครั้ง','success');
              this.dialog = false
            }
          })
          .catch(error => handleAjaxError(error, this))
        } else {
          this.$swal('กรุณาอัพโหลดภาพที่ถ่ายกับต้นไม้ของท่าน','','error');
          this.loading_save = false
        }
      } else if(this.attachment.length !== 0){
        this.$swal('กรุณากรอกข้อมูลให้ครบถ้วน','','error');
        this.check = false
        this.loading_save = false
      } else {
        this.$swal('กรุณากรอกข้อมูลให้ครบถ้วน','','error');
        this.check = true
        this.loading_save = false
      }
    }
  }
}

  </script>

  <style scoped>
  .border-upload{
    border: 2px solid #C4C4C4;
    justify-content: center;
    display: flex;
    align-items: center;
    border-radius: 5px;
  }
  .border-upload-warning{
    border: 2px solid red;
    justify-content: center;
    display: flex;
    align-items: center;
    border-radius: 5px;
  }

  #upload_tree .v-btn--active:before, .v-btn:hover:before, .v-btn:focus:before{
    background-color: transparent !important;
  }

  .modal_loading{
    position: absolute;
      background: #4e4e4e70;
      z-index: 1;
      top: 0;
      left: 0;
      height: 100%;
      align-items: center;
      justify-content: center;
      display: flex;
  }
  </style>
